function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 20a10 10 0 100-20 10 10 0 000 20zm-1.165-5.79l3.044-2.92H4.516a.967.967 0 01-.968-.967v-.646a.965.965 0 01.968-.968h7.363L8.835 5.79a.969.969 0 01-.016-1.383l.443-.44a.964.964 0 011.367 0l5.35 5.347a.962.962 0 010 1.367l-5.35 5.354a.962.962 0 01-1.367 0l-.443-.439a.973.973 0 01.016-1.386z",
  fill: "params(fill)"
});

function SvgPrimaryInlineRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgPrimaryInlineRight;